import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import CompanyFilesList from './CompanyFilesList';
import { Card, CardBody, CardTitle, Col, Input, Label, Row } from 'reactstrap';
import { listCompanyFiles, getMyobRedirectionUrl, updateCompanyFiles } from '../../actions/integrationActions';
import { mustBeArray, requestHasError } from '../../utils/lib';
import { FullBaseUrl } from '../../constants';

const IntegrationIndexView = props => {
    const {dispatch, companyData, listCompanyFiles, getMyobRedirectionUrl, updateCompanyFiles} = props;
    const [selectedCompany, setSelectedCompany] = useState([]);
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [saveLoading, setSaveLoading] = useState(false);
    const [myobLoginLoading, setMyobLoginLoading] = useState(false);

    useEffect(() => {
        fetchCompanyFiles();
    }, []);

    const fetchCompanyFiles = () => {
        dispatch(listCompanyFiles()).then(resp => {
            if(!requestHasError({x: resp})){
                setSelectedCompany(resp.data && resp.data.companyFile && resp.data.companyFile.id);
                setUserName(resp.data && resp.data.companyFile && resp.data.companyFile.userName);
            }
        });
    };
    
    const handleCheckboxSelection = row => {
        if(selectedCompany === (row.id)){
            setSelectedCompany("");
            setUserName("");
            setPassword("");
        }
        else{
            setSelectedCompany(row.id);
            if((companyData && companyData.companyFile && companyData.companyFile.id) === row.id){
                setUserName(companyData.companyFile && companyData.companyFile.userName);
            }
            else{
                setUserName("");
            }
        }
    };

    const handleSave = () => {
        if(!selectedCompany){
            return toastr.error("Error: Company File is required.");
        }
        let companyFile = _.find(mustBeArray(companyData && companyData.companyFiles), o => o.id === selectedCompany);
        setSaveLoading(true);
        dispatch(updateCompanyFiles({
            payLoad: {
                id: companyFile && companyFile.id,
                name: companyFile && companyFile.name,
                uri: companyFile && companyFile.uri,
                userName,
                password,
            }
        })).then(resp => {
            setSaveLoading(false);
            if(!requestHasError({x: resp})){
                toastr.success("MYOB Configuration updated.");
            }
        });
    };
    const redirectToMyob = () => {
        setMyobLoginLoading(true);
        dispatch(getMyobRedirectionUrl({returnUrl: `${FullBaseUrl()}/myob-configuration`})).then(resp => {
            if(!requestHasError({x:resp})){
                window.location.replace(resp.data && resp.data.url);
            }
        });
    }
    return(
        <div className="mb-1">
            <div className={"row"}>
                <div className={"col-12"} style={{marginBottom: "24px"}}>
                    <h4>Integrations</h4>
                </div>
            </div>
            <Row>
                <Col sm={12} md={8} lg={6}>
            <Card className="p-1">
                <CardBody>
                    <CardTitle className="mb-1">
                    <span className="mr-h" style={{fontSize: "16px"}}>MYOB Configuration</span>
                        <button type="button" className={`btn btn-success ${myobLoginLoading ? "no-pointer-events" : ""}`} onClick={redirectToMyob}>
                            <i className="fa fa-angle-double-right mr-q" aria-hidden="true"/> 
                            {`${myobLoginLoading ? "Redirecting" : "Login"} to MYOB`}</button>
                    </CardTitle>
                    <CompanyFilesList 
                        list={companyData && companyData.companyFiles}
                        handleCheckboxSelection={handleCheckboxSelection}
                        selectedCompany={selectedCompany}
                    />

            {
                <div className="mt-2 mb-1">
                    <Row className="align-items-center mb-1" style={{marginBottom: '12px'}}>
                        <Col sm={4} md={3}>
                            <Label for="userName">Username</Label>
                        </Col>
                        <Col sm={8} md={9}>
                            <Input 
                                id="userName"
                                value={userName}
                                onChange={e => setUserName(e.target.value)}
                                placeholder="Username"
                            />
                        </Col>
                    </Row>
                    <Row className="align-items-center mb-1" style={{marginBottom: '12px'}}>
                        <Col sm={4} md={3}>
                            <Label for="password">Password</Label>
                        </Col>
                        <Col sm={8} md={9}>
                            <Input 
                                id="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                placeholder="Password"
                                type="password"
                            />
                        </Col>
                    </Row>
                </div>
            }
            <div className="mt-2">
                <button type="button" className={`btn btn-primary ${saveLoading ? "no-pointer-events": ""}`} onClick={handleSave}>
                    <i className="fa fa-floppy-o" aria-hidden="true"></i> &nbsp;{saveLoading ? "Saving": "Save"}
                </button>
            </div>
            </CardBody>
            </Card>
            </Col>
            </Row>
        </div>
    );
};

function mapStateToProps(state, ownProps){
    return {
      filters: state.rebatesRCTI && state.rebatesRCTI.listFilters || {},
      companyData: state.integrations && state.integrations.companyFiles || {}
    };
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      dispatch,
      listCompanyFiles,
      getMyobRedirectionUrl,
      updateCompanyFiles
    };
  }

export default connect(mapStateToProps, mapDispatchToProps) (IntegrationIndexView);